<template>
  <el-select
    v-bind="$attrs"
    v-model="selectedValue"
    filterable
    clearable
    :placeholder="placeholder"
  >
    <!-- v-on="$listeners" -->
    <el-option
      v-for="item in list"
      :key="item.userId"
      :label="item.userName"
      :value="item.userId"
      :disabled="item.disabled"
    />
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-select>
</template>

<script>
  import { getAccountPage } from '@/api/account/account.js'
  export default {
    name: 'YdAdminUserSelect',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      // 查询数据参数
      query: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        list: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    created() {
      this.getList()
    },
    watch: {
      selectedValue: {
        handler() {
          const result = this.list.filter((it) => it.userId === this.selectedValue)
          this.$emit('change', result)
        }
      }
    },
    methods: {
      async getList() {
        const param = {
          current: 1,
          size: 1000,
          ...this.query
        }
        const { code, data } = await getAccountPage(param)
        if (code !== 0) {
          return
        }
        this.list = data && data.records ? data.records : []
      }
    }
  }
</script>

<style lang="scss" scoped></style>
